<!-- Desktop Navbar -->
<div *ngIf="!isSiteOffline" style="display: contents;">
  <div id="navbar" class="w-full hidden lg:block mx-auto bg-light-purple">
    <nav role="navigation" aria-label="Main navigation">
      <div class="flex justify-center">
        <ul class="flex gap-3 text-base bg-light-purple">
          <li *ngFor="let menuItem of navbarItems; trackBy: trackByIndex"
            class="text-black mr-6 mt-[1.5rem] relative group" (focusin)="onFocusIn(menuItem)"
            (focusout)="onFocusOut($event, menuItem)">

            <ng-container *ngIf="!menuItem.childItems; else dropdownMenu">
              <a [routerLink]="menuItem.link"
                routerLinkActive="underline !decoration-solid !decoration-gray-400 decoration-3 text-dark-purple"
                [routerLinkActiveOptions]="{ exact: true }" tabindex="0"
                class="hover:text-gray-400 font-semibold rounded" aria-current="page">
                {{ menuItem.label }}
              </a>
            </ng-container>

            <ng-template #dropdownMenu>
              <button type="button" (click)="toggleDropdown(menuItem)"
                (keydown)="handleDropdownKeyDown($event, menuItem)"
                class="font-semibold rounded cursor-pointer flex items-center" [attr.aria-haspopup]="true"
                [attr.aria-expanded]="menuItem.open" [attr.aria-controls]="'submenu-' + menuItem.label">
                {{ menuItem.label }}
                <i class="uil uil-angle-down text-md text-dark-purple ml-1" aria-hidden="true"></i>
              </button>

              <ul *ngIf="menuItem.open" role="menu" tabindex="-1" [attr.id]="'submenu-' + menuItem.label"
                [attr.aria-label]="menuItem.label + ' submenu, ' + menuItem.childItems?.length + ' items'"
                class="absolute left-0 mt-2 w-48 bg-white border rounded shadow-lg z-10">
                <li *ngFor="let childItem of menuItem.childItems; trackBy: trackByIndex" role="menuitem" tabindex="0"
                  (click)="onChildItemClick(menuItem, childItem)" (focusin)="onFocusIn(menuItem)"
                  (keydown)="handleMenuItemKeyDown($event, childItem)"
                  class="block px-4 py-2 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-dark-purple">
                  {{ childItem.label }}
                </li>
              </ul>
            </ng-template>
          </li>
        </ul>

        <div *ngIf="!isLoggedIn && !isFooter" class="text-black bg-light-purple">
          <a class="font-semibold flex ml-4 mt-[24px]" role="button" tabindex="0" (click)="onLoginClick()"
            (keydown.enter)="onLoginClick()" (keydown.space)="onLoginClick()">Log In</a>
        </div>
      </div>
    </nav>
  </div>

  <div *ngIf="isFooter" id="footer-navbar" class="w-full block lg:hidden mx-auto bg-light-purple">
    <nav role="navigation" aria-label="Footer navigation">
      <div class="flex justify-center">
        <ul class="flex gap-3 text-base bg-light-purple">
          <li class="text-black mt-[1.5rem] relative group">
            <a href='/contact-us' tabindex="0" class="hover:text-gray-400 font-semibold rounded">
              Contact Us
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </div>

  <!-- Mobile Menu -->
  <div *ngIf="openSideMenu" class="fixed top-0 right-0 !z-[2000] bg-white w-64 h-full shadow-lg">
    <nav role="navigation" aria-label="Mobile navigation">
      <div class="flex justify-end mt-10 pr-10">
        <i *ngIf="openSideMenu" class="text-4xl uil uil-bars relative z-[2000] cursor-pointer"
          (click)="handleSideMenuToggle()">
        </i>
      </div>

      <div class="flex items-center mt-4 px-4">
        <img [src]="iconImgUrl" class="w-6 mr-2" alt="User Icon">
        <ng-container *ngIf="!isLoggedIn; else userMenu">
          <a class="font-bold" (click)="onLoginClick()">Log in</a>
        </ng-container>
        <ng-template #userMenu>
          <details>
            <summary class="cursor-pointer font-bold">{{ userFullName }}</summary>
            <ul class="ml-4">
              <li><a (click)="navigate(accountSettingsLink)" class="block py-1">Account Settings</a></li>
            </ul>
          </details>
        </ng-template>
      </div>

      <ul class="mt-6 px-4">
        <ng-container *ngFor="let menuItem of navbarItems">
          <ng-container *ngIf="!menuItem.childItems; else mobileSubMenu">
            <li class="py-2">
              <a (click)="navigate(menuItem.link)" class="hover:text-gray-400 font-semibold"
                [ngClass]="{ 'underline !decoration-solid !decoration-dark-purple decoration-3 text-dark-purple': isActive(menuItem.link) }">
                {{ menuItem.label }}
              </a>
            </li>
          </ng-container>

          <ng-template #mobileSubMenu>
            <details class="py-2">
              <summary class="font-semibold cursor-pointer">{{ menuItem.label }}</summary>
              <ul class="ml-4">
                <li *ngFor="let childItem of menuItem.childItems; trackBy: trackByIndex">
                  <a (click)="onChildItemClick(menuItem, childItem)" class="block py-1 cursor-pointer">{{
                    childItem.label }}</a>
                </li>
              </ul>
            </details>
          </ng-template>
        </ng-container>

        <li *ngIf="isLoggedIn" class="py-2">
          <a (click)="logout()" class="hover:text-gray-400 font-semibold">Log Out</a>
        </li>
      </ul>
    </nav>
  </div>
</div>